export default {"src":"/_next/static/media/dfk.2bd1f0e4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};